module.exports = __webpack_public_path__ + "img/timeonline-logo-01.52a12a21.svg";